// Model.js
// -----------------------
// @module Case
define("Finis.FinisAging.aging.SS2Model", [
  "Backbone",
  "Utils",
  "SCModel",
], function (Backbone, Utils, SCModelModule) {
  "use strict";

  // @class Case.Fields.Model @extends Backbone.Model
  var SCModel = SCModelModule.SCModel;

  function AgingPrefernceModel() {
    SCModel.call(this);

    this.urlRoot = function urlRoot() {
      return Utils.getAbsoluteUrl(
        getExtensionAssetsPath("Modules/aging/SuiteScript2/aging.Service.ss"),
        true
      );
    };
  }

  AgingPrefernceModel.prototype = Object.create(SCModel.prototype);
  AgingPrefernceModel.prototype.constructor = AgingPrefernceModel;
  return AgingPrefernceModel;
});
